<template>
  <div class="layout">
    <Layout class="main-layout">
      <Sider width="240" collapsible hide-trigger class="fixed-sider">
        <div class="logo">
          <img src="@/assets/Trademark-logo.png" :alt="$t('adminLayout.systemLogo')" class="logo-img" />
          <h3>{{ $t('login.Longtail') }}</h3>
        </div>
        <div class="sidebar-menu-container">
          <Menu theme="dark" width="auto" :active-name="routerPath" accordion>
            <Submenu name="home">
              <template #title>
                <Icon type="ios-home" />
                {{ $t('adminLayout.home') }}
              </template>
              <MenuItem name="/admin/Welcome" to="/admin/Welcome">
              {{ $t('adminLayout.welcomePage') }}
              </MenuItem>
            </Submenu>
            <Submenu name="shopManage">
              <template #title>
                <Icon type="ios-home" />
                {{ $t('adminLayout.shopManage') }}
              </template>
              <MenuItem name="/admin/shopManage" to="/admin/shopManage">
              {{ $t('adminLayout.shopManage') }}
              </MenuItem>
              <MenuItem name="/admin/shopOrderManage" to="/admin/shopOrderManage">
              {{ $t('adminLayout.shopOrder') }}
              </MenuItem>
            </Submenu>
            <!-- 模板管理分组 -->
            <Submenu name="template">
              <template #title>
                <Icon type="ios-analytics" />
                {{ $t('adminLayout.templateManage') }}
              </template>
              <MenuItem name="/admin/tempTypeManage" to="/admin/tempTypeManage">
              {{ $t('adminLayout.templateCategory') }}
              </MenuItem>
              <MenuItem name="/admin/tempManage" to="/admin/tempManage">
              {{ $t('adminLayout.templateList') }}
              </MenuItem>
            </Submenu>
            <!-- 商品管理分组 -->
            <Submenu name="commodiy">
              <template #title>
                <Icon type="ios-card" />
                {{ $t('adminLayout.commodityManage') }}
              </template>
              <MenuItem name="/admin/commodiytypeManage" to="/admin/commodiytypeManage">
              {{ $t('adminLayout.commodityCategory') }}
              </MenuItem>
              <MenuItem name="/admin/commodiyProTypeManage" to="/admin/commodiyProTypeManage">
              {{ $t('adminLayout.commodityProType') }}
              </MenuItem>
              <MenuItem name="/admin/commodiyManage" to="/admin/commodiyManage">
              {{ $t('adminLayout.commodityList') }}
              </MenuItem>
              <MenuItem name="/admin/commodiyorderManage" to="/admin/commodiyorderManage">
              {{ $t('adminLayout.commodityOrder') }}
              </MenuItem>
              <MenuItem name="/admin/commodiyTemplate" to="/admin/commodiyTemplate">
              {{ $t('adminLayout.commodityTemplate') }}
              </MenuItem>
              <MenuItem name="/admin/attriButes" to="/admin/attriButes">
              {{ $t('skus.productAttributes') }}
              </MenuItem>
              <MenuItem name="/admin/attriButesValue" to="/admin/attriButesValue">
              {{ $t('skus.productAttributeValue') }}
              </MenuItem>
              <MenuItem name="/admin/h5banner" to="/admin/h5banner">
              商品首页配置
              </MenuItem>
            </Submenu>

            <!-- 异形商品管理分组 -->
            <Submenu name="differentForm">
              <template #title>
                <Icon type="md-photos" />
                {{ $t('adminLayout.differentFormManage') }}
              </template>
              <MenuItem name="/admin/meterialQualityManage" to="/admin/meterialQualityManage">
              {{ $t('adminLayout.materialQuality') }}
              </MenuItem>
              <MenuItem name="/admin/filmCoverManage" to="/admin/filmCoverManage">
              {{ $t('adminLayout.filmCoverMaterial') }}
              </MenuItem>
              <MenuItem name="/admin/outsideComponentsManage" to="/admin/outsideComponentsManage">
              {{ $t('adminLayout.outsideComponents') }}
              </MenuItem>
              <MenuItem name="/admin/DfbgImgManage" to="/admin/DfbgImgManage">
              {{ $t('adminLayout.backgroundImageManage') }}
              </MenuItem>
              <MenuItem name="/admin/DfSizeManage" to="/admin/DfSizeManage">
              {{ $t('adminLayout.sizeManage') }}
              </MenuItem>
              <MenuItem name="/admin/DfCommodityManage" to="/admin/DfCommodityManage">
              {{ $t('adminLayout.differentFormCommodity') }}
              </MenuItem>
            </Submenu>

            <!-- 3D渲染管理分组 -->
            <Submenu name="3DrenderingManagement">
              <template #title>
                <Icon type="md-images" />
                {{ $t('adminLayout.3dRenderingManage') }}
              </template>
              <MenuItem name="/admin/normalMaterial" to="/admin/normalMaterial">
              {{ $t('adminLayout.materialManage') }}
              </MenuItem>
              <MenuItem name="/admin/renderingMaterialManagement" to="/admin/renderingMaterialManagement">
              {{ $t('adminLayout.modelManage') }}
              </MenuItem>
            </Submenu>

            <!-- AI工具分组 -->
            <Submenu name="ai">
              <template #title>
                <Icon type="ios-brush" />
                {{ $t('adminLayout.aiTools') }}
              </template>
              <MenuItem name="/admin/aiStyleManage" to="/admin/aiStyleManage">
              {{ $t('adminLayout.stylePromptManage') }}
              </MenuItem>
              <MenuItem name="/admin/rechargeManage" to="/admin/rechargeManage">
              {{ $t('adminLayout.rechargeManage') }}
              </MenuItem>
            </Submenu>

            <!-- 素材管理分组 -->
            <Submenu name="material">
              <template #title>
                <Icon type="ios-ribbon" />
                {{ $t('adminLayout.materialManageGroup') }}
              </template>
              <MenuItem name="/admin/materialTypeManage" to="/admin/materialTypeManage">
              {{ $t('adminLayout.materialCategory') }}
              </MenuItem>
              <MenuItem name="/admin/materialManage" to="/admin/materialManage">
              {{ $t('adminLayout.materialList') }}
              </MenuItem>
            </Submenu>
            <Submenu name="background">
              <template #title>
                <Icon type="ios-color-wand" />
                {{ $t('adminLayout.backgroundManage') }}
              </template>
              <MenuItem name="/admin/backgroundType" to="/admin/backgroundType">
              {{ $t('adminLayout.backgroundCategory') }}
              </MenuItem>
              <MenuItem name="/admin/backgroundManage" to="/admin/backgroundManage">
              {{ $t('adminLayout.backgroundList') }}
              </MenuItem>
            </Submenu>

            <!-- 字体管理分组 -->
            <Submenu name="font">
              <template #title>
                <Icon type="logo-tumblr" />
                {{ $t('adminLayout.fontManage') }}
              </template>
              <MenuItem name="/admin/fontborderManage" to="/admin/fontborderManage">
              {{ $t('adminLayout.fontEffect') }}
              </MenuItem>
              <MenuItem name="/admin/fontManage" to="/admin/fontManage">
              {{ $t('adminLayout.fontList') }}
              </MenuItem>
            </Submenu>
            <Submenu name="combination">
              <template #title>
                <Icon type="ios-browsers" />
                {{ $t('adminLayout.textCombinationManage') }}
              </template>
              <MenuItem name="/admin/fontsTypeManage" to="/admin/fontsTypeManage">
              {{ $t('adminLayout.textCombinationCategory') }}
              </MenuItem>
              <MenuItem name="/admin/fontstyleManage" to="/admin/fontstyleManage">
              {{ $t('adminLayout.textCombinationList') }}
              </MenuItem>
            </Submenu>
            <Submenu name="userManage">
              <template #title>
                <Icon type="ios-contacts" />
                {{ $t('adminLayout.userManage') }}
              </template>
              <MenuItem name="/admin/userManage" to="/admin/userManage">
              {{ $t('adminLayout.userList') }}
              </MenuItem>
              <MenuItem name="/admin/userCoinManage" to="/admin/userCoinManage">
              {{ $t('adminLayout.userPoints') }}
              </MenuItem>
              <MenuItem name="/admin/userFont" to="/admin/userFont">
              {{ $t('adminLayout.userFont') }}
              </MenuItem>
              <MenuItem name="/admin/userMaterial" to="/admin/userMaterial">
              {{ $t('adminLayout.userMaterial') }}
              </MenuItem>
              <MenuItem name="/admin/userTempl" to="/admin/userTempl">
              {{ $t('adminLayout.userTemplate') }}
              </MenuItem>
              <MenuItem name="/admin/userComponent" to="/admin/userComponent">
              {{ $t('adminLayout.userComponent') }}
              </MenuItem>
            </Submenu>

            <Submenu name="vipManage">
              <template #title>
                <Icon type="ios-school" />
                {{ $t('adminLayout.vipManage') }}
              </template>
              <MenuItem name="/admin/vipconfigManage" to="/admin/vipconfigManage">
              {{ $t('adminLayout.vipLevel') }}
              </MenuItem>
              <MenuItem name="/admin/vipUserManage" to="/admin/vipUserManage">
              {{ $t('adminLayout.vipList') }}
              </MenuItem>
            </Submenu>
            <!-- 其他管理选项 -->
            <!-- <MenuItem name="/admin/vipconfigManage" to="/admin/vipconfigManage">
              <Icon type="ios-contact" />
              会员等级管理
            </MenuItem> -->
            <MenuItem name="/admin/canvasSizeManage" to="/admin/canvasSizeManage">
            <Icon type="ios-desktop" />
            {{ $t('adminLayout.canvasSize') }}
            </MenuItem>
            <MenuItem name="/admin/bannerManage" to="/admin/bannerManage">
            <Icon type="logo-buffer" />
            {{ $t('adminLayout.advertisement') }}
            </MenuItem>
            <MenuItem name="/admin/noticeManage" to="/admin/noticeManage">
            <Icon type="ios-notifications" />
            {{ $t('adminLayout.websiteNotice') }}
            </MenuItem>
            <MenuItem name="/admin/logo" to="/admin/logo">
            <Icon type="ios-ionic" />
            {{ $t('adminLayout.logoManage') }}
            </MenuItem>
            <MenuItem name="/admin/userAgreement" to="/admin/userAgreement">
            <Icon type="ios-document" />
            {{ $t('adminLayout.userAgreement') }}
            </MenuItem>
          </Menu>
        </div>
      </Sider>
      <Layout class="right-layout">
        <Header class="layout-header">
          <div class="header-content">
            <Icon type="ios-person" size="20" />
            <div class="header-user">{{ userEmail }}</div>
            <Button type="text" @click="logOut">{{ $t('adminLayout.logout') }}</Button>

            <lang></lang>
          </div>
        </Header>
        <Content class="main-content">
          <Card class="content-card" dis-hover>
            <router-view />
          </Card>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script name="Home" setup>
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
import useAdmin from '@/hooks/useAdmin';
import { Message, Modal } from 'view-ui-plus';
import { useI18n } from 'vue-i18n';

import lang from '@/components/top/components/lang.vue';

const { t } = useI18n();
const routerPath = ref('');
const route = useRoute();
const router = useRouter();
const { userInfo, getAdminInfoHander } = useAdmin();
const userEmail = ref('');

const logOut = () => {
  Modal.confirm({
    title: t('adminLayout.logoutConfirm'),
    onOk: () => {
      localStorage.removeItem('AdminToken');
      localStorage.removeItem('email');
      localStorage.removeItem('password');
      Message.success(t('adminLayout.logoutSuccess'));
      setTimeout(() => {
        router.push('/login');
      }, 1000);
    },
  });
};
watch(
  () => route.path,
  () => {
    routerPath.value = route.path;
  }
);

onMounted(async () => {
  routerPath.value = route.path;
  try {
    await getAdminInfoHander();
    userEmail.value = userInfo.value?.email || '';
  } catch (error) {
    console.error('Failed to get admin info:', error);
    userEmail.value = t('adminLayout.notLoggedIn');
  }
});
</script>

// ... existing code ...

<style scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  min-height: 100vh;
  width: 100%;
}

.main-layout {
  height: 100%;
  min-height: 100vh;
}

.fixed-sider {
  position: fixed;
  left: 0;
  height: 100vh;
  overflow: hidden;
  z-index: 10;
  color: #fff;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.08);
}

.right-layout {
  margin-left: 240px;
  min-height: 100vh;
  background: #f5f7f9;
}

.main-content {
  padding: 20px;
  background: #f5f7f9;
}

.content-card {
  min-height: calc(100vh - 40px);
}

.logo {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 30px;
    margin-right: 10px;
  }
}

.logo h3 {
  /* color: #515a6e; */
  margin: 0;
  font-weight: normal;
}

.sidebar-menu-container {
  height: calc(100vh - 64px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* 侧边栏滚动条样式 */
.sidebar-menu-container::-webkit-scrollbar {
  width: 6px;
}

.sidebar-menu-container::-webkit-scrollbar-track {
  background: #000000;
}

.sidebar-menu-container::-webkit-scrollbar-thumb {
  background: #8e8e8e;
  border-radius: 3px;
}

.sidebar-menu-container::-webkit-scrollbar-thumb:hover {
  background: #9f9f9f;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  height: 100%;
}

.header-title {
  font-size: 18px;
  font-weight: 500;
  color: #17233d;
}

.layout-header {
  color: #2d8cf0;
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: #f1f1f1 solid 1px;
}

.layout-footer-center {
  text-align: center;
}

.ivu-layout-sider {
  background: #000000;
}

.ivu-menu-dark {
  background: #191a23;
}

:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title) {
  background: #283247;
}

:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover) {
  color: #fff;
  background: none;
}

:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title) {
  background: #000000;
}

:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover) {
  color: #fff;
}

:deep(.ivu-menu) {
  background: #0000006e;
}

:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu)) {
  color: #fff;
  background: none;
}

:deep(.ivu-layout-header) {
  padding: 0 18px;
}
</style>
